<template>
  <div class="window-render">
    <img
      :style="{
        backgroundImage: 'url(' + planImage.image_thumb + ')',
      }"
      :class="[
        'cursor-zoom',
        {
          'plan-stub': planImage.stub,
        },
      ]"
      :src="planImage.source"
      alt="Планировка"
      @click.prevent="openPopup"
    />

    <div
      role="button"
      class="window-render__zoom-button"
      @click.prevent="openPopup"
    >
      <svg
        width="42"
        height="42"
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 16L1 1M1 1H13.3529M1 1L1 12.4706"
          stroke="#FF0020"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M26 26L41 41M41 41H28.6471M41 41L41 29.5294"
          stroke="#FF0020"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "FlatWindowRender",
  props: {
    planImage: {
      type: Object,
      required: true,
      validator: (value) => {
        return value && typeof value.source === "string";
      },
    },
  },
  methods: {
    openPopup() {
      this.$vfm.show({
        component: "PopupGallery",
        bind: {
          img: [{ src: this.planImage.source }],
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.window-render {
  position: relative;
  padding-bottom: 100%;

  > img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    background-size: cover;

    &.plan-stub {
      opacity: 0.08;
      pointer-events: none;
    }
  }

  &__zoom-button {
    position: absolute;
    right: -80px;
    bottom: 33%;
    z-index: 10;
    width: max-content;

    &:hover {
      cursor: pointer;
    }
  }

  @media (max-width: 575px) {
    padding-bottom: 70%;

    &__zoom-button {
      right: 0;
      bottom: -55px;
      z-index: 10;
      width: max-content;
    }
  }
}
</style>
